import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media } from './styles/breakpoints';
import Icon from './Icon';

const IconWithLabel = ({ label, direction, component, iconProps }) => {
    const StyledWrapper = styled(component)`
        display: flex;
        flex-direction: ${direction === 'bottom' ? 'column' : 'row'};
        align-items: center;
        position: relative;
        line-height: 1;
        color: ${props => iconProps.iconColor ?
        iconProps.iconColor.split('.').reduce((o, i) => o[i], props.theme.palette) :
        props.theme.palette.common.lightBlack};
    `;

    const StyledIconWrapper = styled.p`
        width: ${iconProps.width || '2em'};
        flex-grow: 0;
        margin: 0px;
        margin-right: ${props => direction === 'right' ? props.theme.space[5] : '0px'};
    `;

    const Label = styled.p`
        display: block;
        padding: 0px;
        margin: 0px;
        text-transform: none;
        font-weight: 100;
        opacity: 1;
        transition: font-size 0.2s, opacity 0.2s;
        transition-delay: 0.1s;
        flex-grow: 1;
        
        ${media.tweak900up`
            font-size: ${props => props.theme.fontSizes[8]};
        `}
        
        ${media.normalPortraitUp`
            font-size: ${props => props.theme.fontSizes[7]};
        `}
        
        ${media.smallPortraitOnly`
            font-size: ${props => props.theme.fontSizes[6]};
        `}
    `;

    const IconLabel = (typeof label === 'string' && label.length > 0) ||
    label ?
        <Label >{label}</Label > :
        null;

    return (
        <StyledWrapper >
            <StyledIconWrapper ><Icon {...iconProps} /></StyledIconWrapper >
            {IconLabel}
        </StyledWrapper >
    );
};

IconWithLabel.propTypes = {
    label: PropTypes.node,
    direction: PropTypes.oneOf(['bottom', 'right']),
    component: PropTypes.string,
    iconProps: PropTypes.object,
};

IconWithLabel.defaultProps = {
    direction: 'bottom',
    component: 'div',
    iconProps: {},
    label: null,
};

export default IconWithLabel;



// WEBPACK FOOTER //
// ./src/components/IconWithLabel.js